/* FAIRYDUST theme JS */
(function(){
  var money = function(c){ return (c/100).toLocaleString(undefined,{style:'currency',currency:window.FD_CURRENCY||'EUR'}); };
  var FREE_SHIP = (window.FD_FREE_SHIP||5000);

  /* ---------- helpers ---------- */
  function $(s,c){return (c||document).querySelector(s);}
  function $all(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s));}

  /* ---------- Cart drawer ---------- */
  function openDrawer(){ $('#Drawer')&&$('#Drawer').classList.add('is-on'); $('#Overlay')&&$('#Overlay').classList.add('is-on'); document.body.style.overflow='hidden'; renderCart(); }
  function closeDrawer(){ $('#Drawer')&&$('#Drawer').classList.remove('is-on'); $('#Overlay')&&$('#Overlay').classList.remove('is-on'); document.body.style.overflow=''; }

  var GIFT = FREE_SHIP + 2500; // free gift tier (free shipping + €25)
  function shipMsg(total){
    var pct, label;
    if(total>=GIFT){ pct=100; label='<strong>Free shipping + your free gift unlocked!</strong> Lovely choice.'; }
    else if(total>=FREE_SHIP){ pct=Math.round(total/GIFT*100); label='<strong>Free shipping unlocked!</strong> Add '+money(GIFT-total)+' more for a <strong>free gift</strong>.'; }
    else { pct=Math.round(total/FREE_SHIP*100); label='Add <strong>'+money(FREE_SHIP-total)+'</strong> more to get <strong>free shipping</strong>.'; }
    return '<p class="shipbar__t">'+label+'</p><span class="shipbar__track"><span class="shipbar__fill" style="width:'+Math.min(100,pct)+'%"></span></span>';
  }

  function imgSize(u,w){ if(!u) return ''; return u + (u.indexOf('?')>-1?'&':'?') + 'width='+w; }

  function renderCart(){
    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      $all('.cartcount').forEach(function(el){el.textContent=cart.item_count;});
      var ship=$('#DrawerShip'); if(ship){ ship.style.display=cart.item_count?'block':'none'; ship.innerHTML=shipMsg(cart.total_price); }
      var body=$('#DrawerBody'), foot=$('#DrawerFoot');
      if(!body) return;
      if(cart.item_count===0){
        body.innerHTML='<div class="drawer__empty"><div style="font-size:38px">🔮</div><h3 style="font-family:var(--serif);font-size:22px">Your cart is empty</h3><p>Something magical is waiting for you.</p><a class="btn btn--primary" href="/collections/all">Shop Bestsellers →</a></div>';
        if(foot)foot.style.display='none'; return;
      }
      if(foot)foot.style.display='block';
      body.innerHTML=cart.items.map(function(it,i){
        var line=i+1;
        return '<div class="citem--d">'+
          '<a href="'+it.url+'"><img src="'+imgSize(it.image,140)+'" alt="" loading="lazy"></a>'+
          '<div>'+
            '<a class="citem__t" href="'+it.url+'">'+it.product_title+'</a>'+
            (it.variant_title&&it.variant_title!=='Default Title'?'<div class="citem__v">'+it.variant_title+'</div>':'')+
            '<div class="citem__ctrl">'+
              '<span class="qtystep">'+
                '<button type="button" data-line-qty="'+line+':'+(it.quantity-1)+'" aria-label="Decrease quantity">−</button>'+
                '<span>'+it.quantity+'</span>'+
                '<button type="button" data-line-qty="'+line+':'+(it.quantity+1)+'" aria-label="Increase quantity">+</button>'+
              '</span>'+
              '<button type="button" class="citem__rm2" data-line-qty="'+line+':0">Remove</button>'+
            '</div>'+
          '</div>'+
          '<div class="citem__p">'+money(it.final_line_price)+'</div>'+
        '</div>';
      }).join('')
      +'<div class="cart-upsell" id="DrawerUpsell" style="display:none"><p class="cart-upsell__h">You may also love</p><div id="DrawerUpsellList"></div></div>';
      // upsell suggestions are styled as a tinted box so they never read as cart items
      var sub=$('#DrawerSubtotal'); if(sub)sub.textContent=money(cart.total_price);
      renderUpsell(cart);
    });
  }

  /* drawer quantity steppers / remove */
  document.addEventListener('click',function(e){
    var q=e.target.closest('[data-line-qty]');
    if(!q) return;
    e.preventDefault();
    var parts=q.getAttribute('data-line-qty').split(':');
    q.disabled=true;
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:parseInt(parts[0]),quantity:Math.max(0,parseInt(parts[1]))})})
      .then(function(r){return r.json();}).then(function(){ renderCart(); })
      .catch(function(){ q.disabled=false; });
  });

  function renderUpsell(cart){
    var wrap=$('#DrawerUpsell'), list=$('#DrawerUpsellList');
    if(!wrap||!list||!cart.items.length){ if(wrap)wrap.style.display='none'; return; }
    var inCart={}; cart.items.forEach(function(i){inCart[i.product_id]=1;});
    fetch('/recommendations/products.json?product_id='+cart.items[0].product_id+'&limit=4&intent=related')
      .then(function(r){return r.json();}).then(function(d){
        var items=(d.products||[]).filter(function(p){return !inCart[p.id];}).slice(0,2);
        if(!items.length){ wrap.style.display='none'; return; }
        list.innerHTML=items.map(function(p){
          var img=(p.featured_image||(p.images&&p.images[0])||'');
          return '<div class="cart-upsell__item"><img src="'+img+'" alt=""><span class="cart-upsell__name">'+p.title+'</span><span class="cart-upsell__price">'+money(p.price)+'</span><button class="cart-upsell__add" data-quick-add="'+p.variants[0].id+'">+ Add</button></div>';
        }).join('');
        wrap.style.display='block';
      }).catch(function(){ wrap.style.display='none'; });
  }

  window.fdRenderCart=renderCart; window.fdOpenCart=openDrawer;

  document.addEventListener('click',function(e){
    if(e.target.closest('[data-cart-open]')){e.preventDefault();openDrawer();}
    if(e.target.closest('[data-cart-close]')||e.target.id==='Overlay'){closeDrawer();}
    var qa=e.target.closest('[data-quick-add]');
    if(qa){ e.preventDefault(); var id=qa.getAttribute('data-quick-add'); if(!id)return;
      var t=qa.textContent; qa.textContent='Adding…';
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:id,quantity:1})})
      .then(function(){qa.textContent=t;openDrawer();}).catch(function(){qa.textContent=t;});
    }
  });

  /* ---------- Mobile nav ---------- */
  document.addEventListener('click',function(e){
    if(e.target.closest('#Burger')){ $('#NavDrawer')&&$('#NavDrawer').classList.add('is-on'); $('#Overlay')&&$('#Overlay').classList.add('is-on'); }
    if(e.target.closest('#NavClose')){ $('#NavDrawer')&&$('#NavDrawer').classList.remove('is-on'); $('#Overlay')&&$('#Overlay').classList.remove('is-on'); }
  });

  /* ---------- FAQ / accordion single-open not enforced (native details) ---------- */

  /* ---------- Header scroll shadow ---------- */
  window.addEventListener('scroll',function(){ var h=$('#Head'); if(h) h.style.boxShadow=window.scrollY>8?'var(--glow-soft)':'none'; },{passive:true});

  /* ---------- PDP logic ---------- */
  var pdp=$('#Pdp');
  if(pdp && window.FD_VARIANTS){
    var variants=window.FD_VARIANTS, sel={};
    $all('.swatch,.pill').forEach(function(b){ if(b.classList.contains('is-active')) sel[b.getAttribute('data-opt')]=b.getAttribute('data-val'); });

    /* gallery: thumbnail picker switches the main stage image */
    var slides=$all('.gallery__slide'), thumbs=$all('.gallery__thumb');
    function showSlide(idx){
      idx=String(idx);
      slides.forEach(function(s){ var on=s.getAttribute('data-idx')===idx; s.classList.toggle('is-active',on); var v=s.querySelector('video'); if(v&&!on&&v.pause){try{v.pause();}catch(e){}} });
      thumbs.forEach(function(t){ t.classList.toggle('is-active',t.getAttribute('data-idx')===idx); });
    }
    thumbs.forEach(function(t){ t.addEventListener('click',function(){ showSlide(t.getAttribute('data-idx')); }); });

    function currentVariant(){
      return variants.find(function(v){ return v.options.every(function(val,i){ return sel[i]==null||sel[i]===val; }); });
    }
    function applyVariant(){
      var v=currentVariant(); if(!v)return;
      var idEl=$('#VariantId'); if(idEl) idEl.value=v.id;
      var now=$('#PriceNow'), was=$('#PriceWas');
      if(now) now.textContent=money(v.price);
      if(was){ was.style.display=(v.compare_at_price>v.price)?'':'none'; if(v.compare_at_price>v.price) was.textContent=money(v.compare_at_price); }
      var sp=$('#StickyPrice'); if(sp) sp.textContent=money(v.price);
      /* switch the main image to the variant's own media */
      if(v.featured_media && v.featured_media.id){ var sl=$('[data-media-id="'+v.featured_media.id+'"]'); if(sl) showSlide(sl.getAttribute('data-idx')); }
    }
    $all('.swatch,.pill').forEach(function(b){
      b.addEventListener('click',function(){
        var opt=b.getAttribute('data-opt');
        $all('[data-opt="'+opt+'"]').forEach(function(x){x.classList.remove('is-active');});
        b.classList.add('is-active'); sel[opt]=b.getAttribute('data-val');
        var lbl=$('#optval-'+opt); if(lbl) lbl.textContent=b.getAttribute('data-val');
        applyVariant();
      });
    });

    /* bundle selector -> sets quantity for both the AJAX add and the express (Shop Pay) button */
    var bundleQty=1, qtyEl=$('#PdpQty');
    function syncQty(q){ bundleQty=parseInt(q)||1; if(qtyEl) qtyEl.value=bundleQty; }
    var act=$('.bundle.is-active'); if(act) syncQty(act.getAttribute('data-qty'));
    $all('.bundle').forEach(function(b){
      b.addEventListener('click',function(){
        $all('.bundle').forEach(function(x){x.classList.remove('is-active');});
        b.classList.add('is-active'); syncQty(b.getAttribute('data-qty'));
      });
    });

    /* add to cart (AJAX + drawer). The express button submits natively to checkout. */
    var form=$('#PdpForm');
    if(form) form.addEventListener('submit',function(e){
      e.preventDefault();
      var btn=$('#AtcBtn'); var txt=btn.textContent; btn.textContent='Adding…'; btn.disabled=true;
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:parseInt($('#VariantId').value),quantity:bundleQty})})
      .then(function(r){ if(!r.ok) throw 0; return r.json(); })
      .then(function(){ btn.textContent=txt; btn.disabled=false; openDrawer(); })
      .catch(function(){ btn.textContent='Try again'; btn.disabled=false; });
    });

    /* sticky ATC on scroll */
    var atcBox=$('#AtcBox'), sticky=$('#StickyAtc');
    if(atcBox&&sticky&&'IntersectionObserver' in window){
      new IntersectionObserver(function(en){ sticky.classList.toggle('is-on',!en[0].isIntersecting); },{threshold:0}).observe(atcBox);
    }
    $('#StickyAtcBtn')&&$('#StickyAtcBtn').addEventListener('click',function(){ if(!form)return; if(form.requestSubmit)form.requestSubmit(); else form.dispatchEvent(new Event('submit',{cancelable:true})); });

    applyVariant();
  }

  /* init counts */
  fetch('/cart.js').then(function(r){return r.json();}).then(function(c){ $all('.cartcount').forEach(function(el){el.textContent=c.item_count;}); });
})();
